import api from '../../utils/api'

export const state = {
  categoryFrequentlyAskedQuestionsMeta: {},
  categoriesFrequentlyAskedQuestions: []
}

export const mutations = {
  SET_CATEGORY_FREQUENTLY_ASKEDQUESTIONS_META(state, categoryFrequentlyAskedQuestionsMeta) {
    state.categoryFrequentlyAskedQuestionsMeta = categoryFrequentlyAskedQuestionsMeta
  },
  SET_CATEGORIES_FREQUENTLY_ASKEDQUESTIONS(state, categoriesFrequentlyAskedQuestions) {
    state.categoriesFrequentlyAskedQuestions = categoriesFrequentlyAskedQuestions
  }
}

export const actions = {
  async handleCreate(_, body) {
    try {
      return await api.post('/category-frequently-asked-questions', body)
    } catch (e) {

    }
  },

  async handleUpdate(_, body) {
    try {
      return await api.put(`/category-frequently-asked-questions/${body._id}`, body)
    } catch (e) {

    }
  },

  async handleSetOpen(_, body) {
    try {
      return await api.put(`/category-frequently-asked-questions/${body._id}/open`, body)
    } catch (e) {

    }
  },

  async handleGet(_, _id) {
    try {
      return await api.get(`/category-frequently-asked-questions/${_id}`)
    } catch (e) {

    }
  },

  async handleDelete(_, _id) {
    try {
      return await api.delete(`/category-frequently-asked-questions/${_id}`)
    } catch (e) {

    }
  },


  async handlePagedList({ commit }, payload) {
    try {
      let params = {}
      if (payload) {
        params = {
          name: payload.name || '',
          page: payload.page || 1,
          limit: payload.limit || 10,
          categoryWithQuestions: payload.categoryWithQuestions ? Boolean(payload.categoryWithQuestions) : false
        }
      }

      const { data: response } = await api.get('/category-frequently-asked-questions', { params })
      if(!payload.categoryWithQuestions) {
        commit('SET_CATEGORY_FREQUENTLY_ASKEDQUESTIONS_META', response.meta)
        commit('SET_CATEGORIES_FREQUENTLY_ASKEDQUESTIONS', response.data.itens)
      }
      return response
    } catch (e) {

    }
  },
  async handlePagedListRelated(_, payload) {
    try {
      let params = {}
      if (payload) {
        params = {
          page: payload.page || 1,
          limit: payload.limit || 3
        }
      }
      const { data: response } = await api.get('/category-frequently-asked-questions', { params })
      const {data} = response
      const {itens} = data
      return itens
    } catch (e) {

    }
  },
  async updateError({ commit }, error) {
    commit('SET_ERROR', error)
  },
  async updateMenuCollapsed({ commit }, menuCollapsed) {
    commit('SET_MENU_COLLAPSED', menuCollapsed)
  }
}

export const getters = {
  categoryFrequentlyAskedQuestionsMeta: (state) => state.categoryFrequentlyAskedQuestionsMeta,
  categoriesFrequentlyAskedQuestions: (state) => state.categoriesFrequentlyAskedQuestions,
}
